import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Input, Field, Button, Alert, Stack, Flex } from '@chakra-ui/react';
import { LuLogIn } from "react-icons/lu";
import axios from 'axios';
import PageContent, {pageContentGap} from 'components/ui/PageContent';
import PageTitle from 'components/ui/PageTitle';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  
  if (localStorage.getItem('access_token')) {
    // log out
    axios.post('/auth/jwt/logout',
      null,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
      }
    )
    .then((response) => {
        console.log(response);
    })
    .catch((error) => console.log(error));
    localStorage.removeItem('access_token');
    localStorage.removeItem('is_superuser');

    // trigger a re-render
    window.location.reload();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Create FormData object
      const formDataObj = new FormData();
      formDataObj.set('username', formData.email); // Note: API expects 'username' field
      formDataObj.set('password', formData.password);

      const response = await axios.post('/auth/jwt/login', formDataObj, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Store the token with its type
      localStorage.setItem('access_token', response.data.access_token);
      console.log(response.data)
      
      //get profile
      try{
        const responseProfile = await axios.get(
          '/users/me', {
          headers: {
              'Authorization': `Bearer ${response.data.access_token}`,
          },
        });
        console.log(responseProfile.data);
        localStorage.setItem("is_superuser", responseProfile.data.is_superuser);
        localStorage.setItem("user_id", responseProfile.data.id);
    }catch (error) {
        localStorage.setItem("is_superuser", false);
        console.log(error);
        console.log(error.response?.data?.detail || 'Profile failed');
      }
      
      // const from = location.state?.from?.pathname || '/';
      // navigate(from, { replace: true });
      navigate('/search', { replace: true });
    } catch (error) {
        console.log(error);
        setError(error.response?.data?.detail || 'Login failed');
    }
  };

  return (
    <PageContent>
      <PageTitle icon={LuLogIn} title="Log In" />

      <form onSubmit={handleSubmit}>
        <Stack gap={pageContentGap} maxW="xs">
          <Field.Root>
            <Field.Label>Email</Field.Label>
            <Input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </Field.Root>

          <Field.Root>
            <Field.Label>Password</Field.Label>
            <Input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            />
          </Field.Root>

          {error && (
            <Alert.Root status="error">
              <Alert.Title>{error}</Alert.Title>
            </Alert.Root>
          )}

          <Button type="submit">Login</Button>
        </Stack>
      </form>
    </PageContent>
  );
}

export default LoginPage;